import React from 'react'

const AddProducts = () => {
  return (
    <div>AddProducts</div>
  )
}

export default AddProducts